import { useState, useEffect } from 'react'
import { ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit } from 'react-icons/ai';
import moment from 'moment';
import { GetPersonalTrainingSubscriptionTeacherTimeTableService } from '../../services/class_booking/classBookingServices';
import { CiStickyNote } from "react-icons/ci";
import { useSelector } from 'react-redux';

function MyTimeTableList() {

  const navigator = useNavigate()

  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const user = useSelector(state=>state.Auth)
  const isTeacher = user?.logged_user_type === 'Teacher'

  const [search, setsearch] = useState({ from_date: '', to_date: '', from_date1: '', to_date1: '' })

  useEffect(() => {
    getdata()
  }, [page])

  async function getdata() {
    // No batch id is passed here on purpose - the backend should scope this to the logged-in teacher's own assignments across all batches
    const response = await GetPersonalTrainingSubscriptionTeacherTimeTableService({ page, from_date: search?.from_date1, to_date: search?.to_date1, personal_training_subscription_teacher_batch: '' });
    setdata(response?.data)
  }

  async function applyFilter() {
    setpage(1)
    const response = await GetPersonalTrainingSubscriptionTeacherTimeTableService({ page: 1, from_date: search?.from_date1, to_date: search?.to_date1, personal_training_subscription_teacher_batch: '' })
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ from_date: '', to_date: '', from_date1: '', to_date1: '' })
    setpage(1)
    const response = await GetPersonalTrainingSubscriptionTeacherTimeTableService({ page: 1, from_date: '', to_date: '', personal_training_subscription_teacher_batch: '' })
    setdata(response?.data)
  }

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
  };

  function editEntry(d) {
    navigator('/batches_booking/list/time_table/edit', {
      state: {
        main_data: d?.personal_training_subscription_teacher_batch || { _id: d?.personal_training_subscription_teacher_batch, mode: d?.mode },
        data: d
      }
    })
  }

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden px-4 pt-5'>

      <h6 className='font-[700] text-[15px]'>My Time Table</h6>
      <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug mb-2'>All the class days you have been assigned to across batches. Open an entry to add your remarks for that day.</h6>

      <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
        <div className='flex items-center justify-between'>
          <h6 className='font-[800] text-[13px]'>Total Assigned Days ({data?.pagination?.total})</h6>
          <div className='flex md:hidden items-center text-[12px]'>
            <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
            <div>
              <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
              <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
            </div>
          </div>
        </div>

        <div className='flex flex-wrap items-center text-[12px] mt-1 md:mt-0'>

          <div className='flex flex-wrap items-center'>

            <div className='hidden md:flex items-center'>
              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>

            <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2 mb-1 md:mb-0' value={search?.from_date} onChange={(v, v1) => { setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

            <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2 mb-1 md:mb-0' value={search?.to_date} onChange={(v, v1) => { setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

          </div>

          <div className='mr-2 mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
          </div>
          <div className='mr-2 mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
          </div>
        </div>
      </div>

      <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

        {data?.datas?.length === 0 &&
          <div className='grid place-items-center mt-20  items-center justify-center'>
            <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
            <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
            <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>You don't have any assigned days in the time table yet.</h6>
          </div>}

        <div className='w-[100%] overflow-hidden'>
          {data?.datas?.length > 0 &&
            <>
            {/* Desktop / tablet table */}
            <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
              <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Date </h6>
                <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Student List</h6>
                <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Batch / Class</h6>
                <h6 className='sticky top-0 z-50  text-[12px] min-w-[200px] w-[200px]  px-2 py-1 font-[600] text-slate-800 border-r'>Topic Covering / Remarks</h6>
                <h6 className='sticky top-0 z-50  text-[12px] min-w-[146px] w-[146px]  px-2 py-1 font-[600] text-slate-800 border-r'>Class Status</h6>
                <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>Action</h6>
              </div>
              {data?.datas?.map((d, i) => (
                <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                  <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>

                  <h6 className=' text-[12px] break-word min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                    <span className='font-bold'>{moment(d?.date)?.format('LL')}</span><br></br>
                    {d?.teacher && <h6 className='bg-blue-100 text-[10px] font-[800] p-1 mt-1'>Teacher :  {d?.teacher?.name}</h6>}
                  </h6>
                  <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                    <h6 className='text-[11px]'>Total Users : {d?.students?.length}</h6>
                    <div className='flex flex-wrap '>
                      {d?.students?.map((s)=><span className='bg-slate-200 text-[11px] p-[4px] m-[4px]'>{s?.name} {!isTeacher && `- [${s?.mobile}]`}</span>)}
                    </div>
                  </h6>
                  <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                    {formatTo12Hour(d?.batch?.start_time)} - {formatTo12Hour(d?.batch?.end_time)} <br></br>
                    {d?.class?.label}
                  </h6>
                  <h6 className='flex break-word  min-w-[200px] w-[200px]  px-2 py-1 font-[500] border-r'> Topic Covering : {d?.topics_covering} <br></br>Remarks : {d?.remarks}</h6>
                  <h6 className='flex break-word  min-w-[146px] w-[146px]  px-2 py-1 break-all capitalize font-[500] border-r'>{d?.class_status}</h6>
                  <h6 className='text-[12px] flex items-start min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>
                    <AiOutlineEdit onClick={() => editEntry(d)} className='mr-2' />
                    {d?.class_status === 'completed' && <CiStickyNote onClick={() => navigator('/batches_booking/list/time_table/student_summary', { state: d })} className='mr-2' />}
                  </h6>
                </div>))}
            </div>

            {/* Mobile card list */}
            <div className='md:hidden mt-3 space-y-2'>
              {data?.datas?.map((d, i) => (
                <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                  <div className='flex items-start justify-between'>
                    <div>
                      <h6 className='text-[13px] font-[700]'>{moment(d?.date)?.format('LL')}</h6>
                      <h6 className='text-[10px] w-max capitalize bg-slate-100 px-1.5 py-0.5 rounded mt-1'>{d?.class_status}</h6>
                    </div>
                    <div className='flex items-center -mr-1.5'>
                      <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => editEntry(d)} /></span>
                      {d?.class_status === 'completed' && <span className='p-2 cursor-pointer'><CiStickyNote size={17} onClick={() => navigator('/batches_booking/list/time_table/student_summary', { state: d })} /></span>}
                    </div>
                  </div>

                  <h6 className='text-[15px] font-[800] text-slate-600 mt-2'>{formatTo12Hour(d?.batch?.start_time)} - {formatTo12Hour(d?.batch?.end_time)} {d?.class?.label && `· ${d?.class?.label}`}</h6>

                  <h6 className='text-[11px] mt-2 font-[600]'>Students ({d?.students?.length || 0})</h6>
                  <div className='flex flex-wrap'>
                    {d?.students?.map((s)=><span key={s?._id} className='bg-slate-100 text-[11px] px-1.5 py-1 rounded m-[3px]'>{s?.name} - [{s?.mobile}]</span>)}
                  </div>

                  {d?.topics_covering && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Topics:</span> {d?.topics_covering}</h6>}
                  {d?.remarks && <h6 className='text-[11px] mt-1'><span className='font-[600]'>Remarks:</span> {d?.remarks}</h6>}
                </div>
              ))}
            </div>
            </>}
        </div>

      </div>

    </div>
  )
}

export default MyTimeTableList
